<template>
  <fn-form-field
    :id="id"
    v-model:value="model"
    :name="name"
    :label="label"
    :class="{
      disabled: disabled,
    }"
    :rules="{
      birthday_day: true,
      birthday_month: true,
      date_in_future: !allowFutureDate,
      birthday_plausibility: !genericError,
      birthday_complete: !genericError,
      date_plausibility: genericError,
      date_complete: genericError,
      required: {
        message: $t('validation.fields.birthday.required'),
      },
      ...rules,
    }"
    :float-label="disabled"
    :validation-mode="validationMode"
    :disabled="disabled"
  >
    <template #default="slotProps">
      <fn-birthday
        :id="slotProps.field.name"
        v-model:value="slotProps.field.value"
        :name="slotProps.field.name"
        :reset="reset"
        :disabled="disabled"
        @blur="slotProps.field.handleBlur"
        @focus="slotProps.field.handleFocus"
        @update:value="slotProps.field.handleChange"
      />
    </template>
    <template #afterLabel="slotProps">
      <slot
        name="afterLabel"
        v-bind="slotProps"
      />
    </template>
  </fn-form-field>
</template>

<script setup lang="ts">
import { defineFormFieldPropsDefaults, type FormFieldProps } from '@/mixins/FormField';

withDefaults(
  defineProps<
    FormFieldProps & {
      allowFutureDate?: boolean;
      genericError?: boolean;
      reset?: boolean;
    }
  >(),
  {
    ...defineFormFieldPropsDefaults(),
    allowFutureDate: true,
  },
);

const model = defineModel<string>('value');
</script>
